import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Descarga y Revisa',
  desc: 'Descarga el protocolo y revisa tu lista de compras rápida (muchas cosas ya las tienes en tu cocina).'
}, {
  num: '2',
  title: 'Aplica el Plan',
  desc: 'Sigue las infusiones y el plan de comidas sencillo durante 7 días consecutivos sin pasar hambre.'
}, {
  num: '3',
  title: 'Observa el Cambio',
  desc: 'Observa cómo desaparece la pesadez, mejora tu digestión y recuperas tu energía vital.'
}];
export function StepsSection() {
  return <section className="py-20 px-4 bg-base" data-id="element-215">
      <div className="max-w-5xl mx-auto" data-id="element-216">
        <div className="text-center mb-16" data-id="element-217">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-3xl md:text-4xl text-primary mb-4" data-id="element-218">
            ¿Cómo funciona?
          </motion.h2>
          <p className="text-ink/70 max-w-2xl mx-auto" data-id="element-219">
            Un proceso simple diseñado para la vida real de una mamá ocupada.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-220">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-accent/30 z-0" data-id="element-221"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-222">
              <div className="w-24 h-24 bg-white rounded-full shadow-md border-4 border-sage flex items-center justify-center mb-6 relative" data-id="element-223">
                <span className="font-heading text-4xl text-accent" data-id="element-224">
                  {step.num}
                </span>
              </div>
              <h3 className="font-bold text-xl text-ink mb-3" data-id="element-225">{step.title}</h3>
              <p className="text-ink/70 leading-relaxed" data-id="element-226">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}